export default "__VITE_ASSET__dTanI$9c__"